module.exports = __webpack_public_path__ + "img/关于我们左侧.9dcdffa0.png";